module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"settings":"Einstellungen","password":"Passwort","useradmin":"Useradministration","main":"Zugang","login":"Anmelden","logout":"Abmelden"},"en":{"settings":"Settings","password":"Password","useradmin":"User administration","main":"Account","login":"Sign in","logout":"Sign out"}}')
  delete Component.options._Ctor
}
